import { Flex, Skeleton } from '@backstage/ui';
import { panel } from './styles';

export type SkeletonSection = {
  titleWidth?: number;
  rows?: Array<{ width: number | string; height: number }>;
};

const DEFAULT_ROWS = [
  { width: '100%', height: 10 },
  { width: '72%', height: 10 },
  { width: '88%', height: 10 },
];

// Mirrors the loaded layout so the page does not jump when data lands.
export const TabSkeleton = ({
  sections = 2,
  columns,
}: {
  sections?: number | SkeletonSection[];
  columns?: string;
}) => {
  const list: SkeletonSection[] =
    typeof sections === 'number'
      ? Array.from({ length: sections }, () => ({}))
      : sections;
  const template =
    columns ??
    (list.length === 2
      ? 'minmax(300px, 380px) minmax(0, 1fr)'
      : `repeat(${list.length}, minmax(0, 1fr))`);

  return (
    <Flex direction="column" gap="4" style={{ padding: '8px 0' }}>
      <Flex
        align="center"
        gap="4"
        style={{ minHeight: 40, padding: '2px 2px 0' }}
      >
        <Skeleton width={96} height={22} style={{ borderRadius: 999 }} />
        <Skeleton width={210} height={12} />
        <Skeleton width={300} height={12} />
        <div style={{ marginLeft: 'auto' }}>
          <Skeleton width={120} height={12} />
        </div>
      </Flex>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: template,
          gap: 16,
          alignItems: 'start',
        }}
      >
        {list.map((section, i) => (
          <div key={i} style={{ ...panel, padding: 12, gap: 10 }}>
            <Skeleton width={section.titleWidth ?? 150} height={14} />
            {(section.rows ?? DEFAULT_ROWS).map((r, j) => (
              <Skeleton key={j} width={r.width} height={r.height} />
            ))}
          </div>
        ))}
      </div>
    </Flex>
  );
};
